import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { CareComponentFilterSetting } from "./CareComponentFilterSetting";
import { ResultsDurationType } from "./ResultsDurationType";

export class FlowsheetFilterSettings {
    public OutsideTreatmentTarget: boolean;
    public OutsideTreatmentFrequency: boolean;
    public ResultsDurationType: ResultsDurationType;
    public StartDate?: string;
    public EndDate?: string;
    public CareComponentFilterSettings?: CareComponentFilterSetting[];

    constructor(args: NonFunctionProperties<FlowsheetFilterSettings>) {
        Object.assign(this, args);
    }

    public static createDefault(careElementFilterSettings: CareComponentFilterSetting[] | null): FlowsheetFilterSettings {
        return new FlowsheetFilterSettings({
            OutsideTreatmentTarget: false,
            OutsideTreatmentFrequency: false,
            ResultsDurationType: ResultsDurationType.All,
            CareComponentFilterSettings: careElementFilterSettings ?? []
        });
    }
}
